import Api, { apiStart, apiEnd, apiError } from "@Api";
import mime from "mime";

export const downloadFile = ({ uri = "", withLoading = false }) => {
	return async (dispatch) => {
		try {
			if (withLoading) {
				dispatch(apiStart());
			}
			const response = await Api.get(`/downloads/${uri}`, {
				responseType: "blob",
			});
			if (!(response.data instanceof Blob)) throw new Error("file not found");
			const file = new Blob([response.data], { type: mime.getType(uri) });
			if (withLoading) {
				dispatch(apiEnd());
			}
			return URL.createObjectURL(file);
		} catch (error) {
			dispatch(apiError(error.message));
			if (withLoading) {
				dispatch(apiEnd());
			}
			return null;
		}
	};
};

export default downloadFile;
